// removed by extract-text-webpack-plugin
module.exports = {"cont":"Posts__cont___1X3Te","item":"Posts__item___2p6Li","itemCont":"Posts__itemCont___SRtKD","image":"Posts__image___tR4by","title":"Posts__title___3KMiD","body":"Posts__body___2yRDh"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Posts/Posts.css
// module id = 751
// module chunks = 0